var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCommand = function SvgIconCommand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.875 3.5a3.625 3.625 0 1 1 0 7.25H15.25v2.5h1.625a3.625 3.625 0 1 1-3.625 3.625V15.25h-2.5v1.625a3.625 3.625 0 1 1-3.625-3.625H8.75v-2.5H7.125a3.625 3.625 0 1 1 3.625-3.625V8.75h2.5V7.125A3.625 3.625 0 0 1 16.875 3.5m-9.75 11.75a1.625 1.625 0 1 0 1.625 1.625V15.25zm8.125 1.625a1.625 1.625 0 1 0 1.625-1.625H15.25zm-4.5-3.625h2.5v-2.5h-2.5zM7.125 5.5a1.625 1.625 0 1 0 0 3.25H8.75V7.125A1.625 1.625 0 0 0 7.125 5.5m9.75 0a1.625 1.625 0 0 0-1.625 1.625V8.75h1.625a1.625 1.625 0 1 0 0-3.25"
  })));
};
export default SvgIconCommand;